import type { RecognizeEmailStep } from "@redotech/redo-flows-common/advanced-flow-db-parser";
import { SchemaType } from "@redotech/redo-flows-common/schemas/schemas";
import type { OmsActionStep } from "@redotech/redo-flows-common/steps";
import { StepType } from "@redotech/redo-flows-core-schema-common/common";
import { memo } from "react";
import type {
  FrontendStepType,
  PartialWithRequiredType,
  StepTypeDetailsProps,
} from ".";
import { ActionEditor } from "./action-editor";
import { omsActionStepType, useOmsActions } from "./oms/oms-action";
import { getRecognizeActions } from "./recognize-email";

type RecognizeActionStep = PartialWithRequiredType<
  OmsActionStep | RecognizeEmailStep
>;

const RecognizeActionInspector = memo(function RecognizeActionInspector(
  props: StepTypeDetailsProps<RecognizeActionStep>,
) {
  const { step, schemaType } = props;
  let omsStep: PartialWithRequiredType<OmsActionStep> | null = null;
  if (step.type === StepType.OMS_ACTION) {
    omsStep = step;
  }
  const omsActions = useOmsActions({
    ...props,
    step: omsStep,
    stepId: step.id,
    nextId: step.nextId,
  });
  let actions = omsActions;
  if (schemaType === SchemaType.RECOGNIZE) {
    actions = [...omsActions, ...getRecognizeActions(props)];
  }
  return <ActionEditor actions={actions} onClose={props.onClose} />;
});

export const recognizeOmsActionStepType: FrontendStepType<RecognizeActionStep> =
  {
    type: "custom",
    valid: (step) =>
      step.type === StepType.OMS_ACTION && omsActionStepType.valid(step),
    customInspector: RecognizeActionInspector,
  };

export const recognizeEmailStepType: FrontendStepType<RecognizeActionStep> = {
  type: "custom",
  valid: (step) =>
    step.type === StepType.RECOGNIZE_EMAIL &&
    Boolean(step.recipientUserIds?.length),
  customInspector: RecognizeActionInspector,
};
